export function Capitalize(data) {
    return data
        .split(' ')
        .map(item => item[0].toUpperCase() + item.slice(1))
        .join(' ');
}

export const convertToCurrency = data => data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 2
});

export const noNairaFormatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

export function TitleCase(data) {
    return `${data[0].toUpperCase()}${data.slice(1)}`;
}

export const checkUndefinedNull = value => value === undefined || value === null;
